import Vue from 'vue';
import Vuetify from 'vuetify';
import VuetifyDialog from 'vuetify-dialog';
import ja from 'vuetify/lib/locale/ja';
import 'vuetify/dist/vuetify.min.css';
import MyApp from '../views/@components/MyApp.vue';
import MyAppUA from '../views/@components/MyAppUA.vue';
import MyMessageDialog from '../views/@components/controls/MyMessageDialog.vue';
import MyCommon from '../views/@components/logics/MyCommon.vue';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#007BFF',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            },
        },
        options: {
            customProperties: true,
        },
    },
    lang: {
        locales: { ja },
        current: 'ja',
    },
});

Vue.use(VuetifyDialog, {
    context: {
        vuetify,
    },
});

const components = {};
const files = require.context('../views/@components/controls', true, /\.vue$/);
files.keys().forEach(key => {
    if (key === 'MyMessageDialog') {
        return;
    }
    components[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default;
});

components.regist = function () {
    // 読み込んだvueファイルをグローバルコンポーネントとして登録
    Object.keys(components).sort().forEach(key => { 
        console.log(key);
        Vue.component(key, components[key]);
    });
};

components.MyApp = MyApp;
components.MyAppUA = MyAppUA;
vuetify.customComponents = components;
Vue.mixin(MyMessageDialog);
Vue.mixin(MyCommon);

export default vuetify;
